import { fetchWithoutToken } from '../utils/fetch';
import { getKajabiCredentials } from './Login/getKajabiCredentials';

export const getInfoUserKajabi = async (codeParam, institutionCode) => {
	try {
		const kajabiCredentials = getKajabiCredentials(institutionCode);
		const redirectUri = kajabiCredentials.redirect_uri;

		const res = await fetchWithoutToken.post(
			`/kajabi`,
			{
				code: codeParam,
				institution_code: institutionCode,
				redirect_uri: redirectUri,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			},
		);

		return res;
	} catch (error) {
		const backendDetail = error?.response?.data?.detail;
		const message = Array.isArray(backendDetail)
			? backendDetail.join(', ')
			: backendDetail || 'Kajabi authentication failed.';
		console.error('Kajabi auth error.', error);
		throw new Error(message);
	}
};
